import {
  InsertRowBelowOutlined,
  InsertRowRightOutlined,
  SaveOutlined,
  SelectOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Collapse,
  Descriptions,
  Row,
  Space,
  Spin,
  Tabs,
  Typography,
  message
} from 'antd';
import axios from 'axios';
import lodashClonedeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import MonedaSelector from '../../components/MonedaSelector';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import SelectableListModal from '../../components/SelectableListModal';
import {
  errorHandler,
  getCriterio,
  getCurrencyInputConfig,
  getDescripcionOpcion
} from '../../utils';
import { instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';
import { fieldTypes } from '../../utils/filter-utils';
import {
  PlanCoberturaItemConfig,
  PlanCoberturaItemMinMaxConfig,
  PlanConfig,
  PlanConfigControles
} from './AdminAseguradoraModals';
import FranquiciaPorRangos from './FranquiciaPorRangos';
import PlanEditor from './PlanEditor';

const { TabPane } = Tabs;
const { Panel } = Collapse;
function PanelHeader(props) {
  const { comision } = props;
  // const urlImage = `/images/empresas/${empresa.codigo}.png`;
  return (
    <Row justify="start" align="middle">
      <Col width="auto">
        {/* <img
          src={urlImage}
          alt="imagen aseguradora"
          width="68px"
          style={{
            verticalAlign: 'top',
            height: '68px',
            objectFit: 'contain'
          }}
        /> */}
      </Col>
      <Col
        style={{
          textAlign: 'start',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          paddingLeft: 20,
          paddingRight: 20
        }}
      >
        Rango Comisión - {comision.valor}%
      </Col>
    </Row>
  );
}

function CardHeader(props) {
  const { corredora, empresa } = props;
  const urlImage = `/images/empresas/${empresa.codigo}.png`;
  return (
    <Row justify="start" align="middle">
      <Col width="auto">
        <img
          src={urlImage}
          alt="imagen aseguradora"
          width="68px"
          style={{
            verticalAlign: 'top',
            height: '68px',
            objectFit: 'contain'
          }}
        />
      </Col>
      <Col
        style={{
          textAlign: 'start',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          paddingLeft: 20,
          paddingRight: 20
        }}
      >
        {corredora}
      </Col>
    </Row>
  );
}
const groupBy = (list, keyGetter, dataGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, {
        data: dataGetter ? dataGetter(item) : item,
        list: [item]
      });
    } else {
      collection.list.push(item);
    }
  });
  return map;
};

const AdminAseguradoraPlanes = () => {
  const [loading, setLoading] = useState(false);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState(false);
  const [model, setModel] = useState();
  const [ultimoId, setUltimoId] = useState(-1);
  const [ultimoIdPlanCoberturaItem, setUltimoIdPlanCoberturaItem] = useState(
    -1
  );
  const [especificos, setEspecificos] = useState();
  const [planesEliminados, setPlanesEliminados] = useState([]);
  const [coberturasEliminadas, setCoberturasEliminadas] = useState([]);
  const [planLoading, setPlanLoading] = useState({});

  const [activeTabEstandar, setActiveTabEstandar] = useState('0');
  const [activeTabEspecifico, setActiveTabEspecifico] = useState({});
  const [openPlanEditor, setOpenPlanEditor] = useState(false);
  const [openPlanFranquiciaEditor, setOpenPlanFranquiciaEditor] = useState(
    false
  );

  const [
    openPlanCoberturaItemEditor,
    setOpenPlanCoberturaItemEditor
  ] = useState(false);
  const [
    openPlanCoberturaItemMinMaxEditor,
    setOpenPlanCoberturaItemMinMaxEditor
  ] = useState(false);
  const [planEdit, setPlanEdit] = useState();
  const [planCoberturaItemEdit, setPlanCoberturaItemEdit] = useState();
  const [coberturaEdit, setCoberturaEdit] = useState();
  const [monedas, setMonedas] = useState();
  const [monedaProductoEstandarList, setMonedaProductoEstandarList] = useState(
    []
  );
  const [monedaProductoList, setMonedaProductoList] = useState([]);
  const [comisionAseguradoraList, setComisionAseguradoraList] = useState([]);

  const {
    params: { id: idAseguradora }
  } = useRouteMatch();

  const columnsCoberturas = [
    {
      title: 'Descripción',
      dataIndex: ['descripcion'],
      key: ['descripcion']
    },
    {
      title: 'Grupo',
      dataIndex: ['grupo', 'descripcion'],
      key: ['grupo', 'descripcion']
    }
  ];

  const columns = [
    {
      title: 'Código',
      dataIndex: 'codigo',
      width: '20%',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Nombre',
      dataIndex: 'descripcion',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Dirección',
      dataIndex: 'direccion',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono',
      filterType: fieldTypes.STRING,
      sortable: true
    } // TODO: Agregar columna que indique que hay configurado
  ];

  const quitarBanderaEdicion = (list) => {
    for (let index = 0; index < list.length; index += 1) {
      const element = list[index];
      for (
        let indexPlan = 0;
        indexPlan < element.planes.length;
        indexPlan += 1
      ) {
        const plan = element.planes[indexPlan];
        for (
          let indexCobertura = 0;
          indexCobertura < plan.planSubcobertura.length;
          indexCobertura += 1
        ) {
          const planSubcobertura = plan.planSubcobertura[indexCobertura];
          if (
            planSubcobertura.monto === -3 ||
            planSubcobertura.monto === '-3'
          ) {
            planSubcobertura.monto = null;
          }
        }
      }
    }
  };

  const validarPlanes = (estandaresConfig, especificosConfig) => {
    // Validacion para coberturas con tipo sumaTablaOVP y sumaTablaRC
    let planesValidados = true;
    const planesEst = estandaresConfig.flatMap((est) => est.planes);
    const planesEsp = especificosConfig.flatMap((esp) => esp.planes);
    const listaDePlanes = [...planesEst, ...planesEsp]; // Obs: los planes y las coberturas eliminadas ya no estan incluidas
    const listaDeSubcoberturas = listaDePlanes.flatMap(
      (plan) => plan.planSubcobertura
    );
    const planSubcoberturasFiltradas = listaDeSubcoberturas.filter(
      ({ subcobertura, monto }) =>
        (subcobertura?.opcion === 'suma_tabla_ovp' ||
          subcobertura?.opcion === 'suma_tabla_rc') &&
        (monto === 0 || monto === null)
    );
    const duracionMensaje = Number(7); // segundos
    for (let i = 0; i < planSubcoberturasFiltradas.length; i += 1) {
      planesValidados = false;
      const planSubcoberturasFiltrada = planSubcoberturasFiltradas[i];
      const plan = listaDePlanes.find(
        (item) => item.id === planSubcoberturasFiltrada.id_plan
      );
      const text = `${
        planSubcoberturasFiltrada?.subcobertura?.cobertura?.descripcion
      } debe ser mayor a cero ${plan.titulo ? `(${plan.titulo})` : ''}`;
      message.error(text, duracionMensaje);
    }
    return planesValidados;
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      const reducer = (previousValue, currentValue) => [
        ...previousValue,
        ...(currentValue.list
          ? currentValue.list.reduce(reducer, [])
          : [currentValue])
      ];

      const est = lodashClonedeep(model);
      const esp = lodashClonedeep(
        Array.from(especificos.values()).reduce(reducer, [])
      );
      quitarBanderaEdicion(est);
      quitarBanderaEdicion(esp);

      const planesValidados = validarPlanes(est, esp);

      if (planesValidados) {
        await instanceRef.instance.post(
          `/aseguradoras/${idAseguradora}/planes`,
          {
            estandares: est,
            especificos: esp,
            planesEliminados,
            coberturasEliminadas
          }
        );
        setLoading(false);
        message.success('Actualizado correctamente');
        loadAseguradora(idAseguradora);
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const onChangeActiveTabEsp = (indexCorredora, index, tab, indexComision) => {
    setActiveTabEspecifico({
      ...activeTabEspecifico,
      [indexCorredora]: { [indexComision]: { [index]: tab } }
    });
  };
  const onChangeActiveTabEst = (indexComision, tab) => {
    setActiveTabEstandar({
      ...activeTabEstandar,
      [indexComision]: tab
    });
  };

  const loadAseguradora = async (id) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(
        `/aseguradoras/${id}/planes`
      );
      setLoading(false);
      if (response.data?.data) {
        const planesEst = response.data.data;
        setModel(planesEst);
      }
      const responseEspecificos = await instanceRef.instance.get(
        `/aseguradoras/${id}/empresas/planes`
      );
      if (responseEspecificos.data?.data) {
        const planesEsp = responseEspecificos.data.data;

        const groupedEmpresa = groupBy(
          planesEsp,
          (item) => item.aseguradoraEmpresa?.empresa?.id || 'empty',
          (item) => item.aseguradoraEmpresa?.empresa
        );
        const sucursalesPreseleccionadas = {};
        groupedEmpresa.forEach((item) => {
          sucursalesPreseleccionadas[item.data.id] = item.data.sucursales.find(
            (suc) => suc.matriz
          );
        });
        setSucursalSeleccionada(sucursalesPreseleccionadas);

        const groupedCorredora = groupBy(
          groupedEmpresa,
          (item) => item.data?.corredora?.id || 'empty',
          (item) => item.data.corredora
        );

        setEspecificos(groupedCorredora);
      }

      setUltimoId(-1);
      setPlanesEliminados([]);
      setCoberturasEliminadas([]);
      // setActiveTabEstandar('0');
      // setActiveTabEspecifico({});
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  const filterSucursal = (listaPlanes, idEmpresa) => {
    return listaPlanes.filter(
      (plan) => plan.id_sucursal === sucursalSeleccionada?.[idEmpresa]?.id
    );
  };

  const agregarCobertura = (modelParam, index, data, comisionId) => {
    const modelArray = [...modelParam];
    const { planes: nuevosPlanes } = modelArray[index];

    let nuevoId = ultimoIdPlanCoberturaItem;
    let planesFiltradoPorSucursal = nuevosPlanes;
    if (modelArray[index].aseguradoraEmpresa) {
      const idEmpresa = modelArray[index].aseguradoraEmpresa.id_empresa;
      const sucursal = sucursalSeleccionada[idEmpresa];
      planesFiltradoPorSucursal = nuevosPlanes.filter(
        (item) =>
          (item.id_sucursal && item.id_sucursal === sucursal.id) ||
          !item.id_sucursal
      );
    }

    const planesFiltradoMoneda = planesFiltradoPorSucursal.filter(
      (item) => item.id_moneda === data.moneda.id
    );

    const planesFiltradoComision = planesFiltradoMoneda.filter(
      (item) => item.id_comision_aseguradora === comisionId
    );
    for (let k = 0; k < data.data.length; k += 1) {
      const nuevaCobertura = data.data[k];
      for (let i = 0; i < planesFiltradoComision.length; i += 1) {
        const plan = planesFiltradoComision[i];
        let posicionNuevoItem = 0;
        let nuevoOrden;
        let existeGrupo = false;

        for (let j = 0; j < plan.planSubcobertura.length; j += 1) {
          const element = plan.planSubcobertura[j];

          if (
            (element.cobertura?.grupo?.orden ||
              element.subcobertura.cobertura.grupo.orden) <=
            nuevaCobertura.grupo.orden
          ) {
            posicionNuevoItem += 1;
          }
          if (
            (element.cobertura?.grupo?.orden ||
              element.subcobertura.cobertura.grupo.orden) ===
            nuevaCobertura.grupo.orden
          ) {
            existeGrupo = true;
            nuevoOrden = element.orden + 1;
          }
        }
        plan.planSubcobertura = plan.planSubcobertura || [];
        plan.planSubcobertura.splice(posicionNuevoItem, 0, {
          id: nuevoId,
          id_plan: plan.id,
          orden: existeGrupo ? nuevoOrden : 1,
          id_cobertura: nuevaCobertura.id,
          cobertura: {
            ...nuevaCobertura
          },
          id_moneda: data.moneda.id,
          moneda: data.moneda,
          monto: ''
        });
        nuevoId -= 1;
      }
    }
    setUltimoIdPlanCoberturaItem(nuevoId);
    message.info('Se agregó una nueva cobertura');
    return modelArray;
  };

  const agregarPlan = async (
    modelParam,
    index,
    init,
    values,
    idComisionAseg
  ) => {
    const modelArray = [...modelParam];
    let planesFiltradoPorSucursal = modelArray[index].planes;
    let sucursal;
    if (modelArray[index].aseguradoraEmpresa) {
      const idEmpresa = modelArray[index].aseguradoraEmpresa.id_empresa;
      sucursal = sucursalSeleccionada[idEmpresa];
      planesFiltradoPorSucursal = modelArray[index].planes.filter(
        (item) =>
          (item.id_sucursal && item.id_sucursal === sucursal.id) ||
          !item.id_sucursal
      );
    }
    const planesFiltradoPorMoneda = planesFiltradoPorSucursal.filter(
      (item) => item.moneda && item.moneda.id === values.moneda.id
    );
    const planesFiltradosPorComision = planesFiltradoPorMoneda.filter(
      (item) =>
        item.comisionAseguradora &&
        item.comisionAseguradora.id === idComisionAseg
    );
    let ultimoPlan = lodashClonedeep(
      planesFiltradosPorComision[planesFiltradosPorComision.length - 1]
    );
    let nuevoPlan;
    const idPlan = ultimoId;
    let idPlanSubcobertura = ultimoIdPlanCoberturaItem;
    setUltimoId(ultimoId - 1);

    if (ultimoPlan) {
      ultimoPlan.id = idPlan;
      ultimoPlan.orden = Number(ultimoPlan.orden) + 1;
      ultimoPlan = { ...ultimoPlan, ...values };
      for (let i = 0; i < ultimoPlan.planSubcobertura.length; i += 1) {
        ultimoPlan.planSubcobertura[i].id = idPlanSubcobertura;
        ultimoPlan.planSubcobertura[i].id_plan = idPlan;
        idPlanSubcobertura -= 1;
      }
      nuevoPlan = ultimoPlan;
    } else {
      nuevoPlan = {
        id: idPlan,
        orden: 1,
        planSubcobertura: [],
        id_moneda: values.moneda.id,
        moneda: values.moneda,
        id_comision_aseguradora: idComisionAseg,
        comisionAseguradora: comisionAseguradoraList.find(
          (item) => item.id === idComisionAseg
        )
      };
      nuevoPlan = { ...nuevoPlan, ...values };

      // Si es uno especifico
      if (modelArray[index].id_aseguradora_empresa) {
        nuevoPlan.id_aseguradora_empresa_producto = modelArray[index].id;
        nuevoPlan.sucursal = sucursal;
        nuevoPlan.id_sucursal = sucursal.id;
      } else {
        // Si es un estandar
        nuevoPlan.id_aseguradora_producto = modelArray[index].id;
      }
    }
    nuevoPlan.controles = [];
    nuevoPlan.montos = [];
    setUltimoIdPlanCoberturaItem(idPlanSubcobertura - 1);
    const responseCreado = await instanceRef.instance.post(
      `/aseguradoras/${idAseguradora}/plan`,
      {
        plan: nuevoPlan
      }
    );
    nuevoPlan = responseCreado.data.data;
    for (let i = 0; i < nuevoPlan.planSubcobertura.length; i += 1) {
      nuevoPlan.planSubcobertura[i].id_plan = nuevoPlan.id;
    }
    const response = await instanceRef.instance.post(
      `/plan/calculo/preliminar`,
      {
        planes: [nuevoPlan]
      }
    );

    const newModel = [
      ...modelParam[index].planes,
      { ...response.data.data[0] }
    ];
    modelArray[index] = { ...modelArray[index], planes: newModel };
    if (!init) {
      message.info('Se agregó un nuevo plan');
    }
    return modelArray;
  };

  const onDeletePlan = (
    modelParam,
    columna,
    index,
    moneda,
    comisionAseguradoraId
  ) => {
    const modelArray = lodashClonedeep(modelParam);
    let planesFiltradoPorSucursal = modelArray[index].planes;
    if (modelArray[index].aseguradoraEmpresa) {
      const idEmpresa = modelArray[index].aseguradoraEmpresa.id_empresa;
      const sucursal = sucursalSeleccionada[idEmpresa];
      planesFiltradoPorSucursal = modelArray[index].planes.filter(
        (item) =>
          (item.id_sucursal && item.id_sucursal === sucursal.id) ||
          !item.id_sucursal
      );
    }

    const planEliminado = planesFiltradoPorSucursal.filter(
      (item) =>
        item.moneda.codigo === moneda.codigo &&
        item.comisionAseguradora.id === comisionAseguradoraId
    )[columna];
    if (planEliminado.id > 0) {
      setPlanesEliminados([...planesEliminados, planEliminado]);
    }

    const modelArrayFiltradoPorMonedaComision = planesFiltradoPorSucursal.filter(
      (item) =>
        item.moneda.codigo === moneda.codigo &&
        item.comisionAseguradora.id === comisionAseguradoraId
    );
    modelArrayFiltradoPorMonedaComision.splice(columna, 1);

    // const modelArrayFiltradoPorMoneda = planesFiltradoPorSucursal.filter(
    //   (item) => item.moneda.codigo === moneda.codigo
    // );
    // modelArrayFiltradoPorMoneda.splice(columna, 1);
    // const newModelMonedas = planesFiltradoPorSucursal.filter(
    //   (item) => item.moneda.codigo !== moneda.codigo
    // );
    // const newModel = [...newModelMonedas, ...modelArrayFiltradoPorMoneda];

    const newModel = planesFiltradoPorSucursal.filter(
      (plan) => plan.id !== planEliminado.id
    );
    modelArray[index] = { ...modelArray[index], planes: newModel };
    return modelArray;
  };

  const onDeleteCobertura = (
    modelParam,
    idCobertura,
    index,
    moneda,
    comisionAseguradoraId
  ) => {
    const modelArray = lodashClonedeep(modelParam);
    const newModel = modelArray[index].planes;
    let planesFiltradoPorSucursal = newModel;
    if (modelArray[index].aseguradoraEmpresa) {
      const idEmpresa = modelArray[index].aseguradoraEmpresa.id_empresa;
      const sucursal = sucursalSeleccionada[idEmpresa];
      planesFiltradoPorSucursal = newModel.filter(
        (item) =>
          (item.id_sucursal && item.id_sucursal === sucursal.id) ||
          !item.id_sucursal
      );
    }
    const planesFiltradoPorMonedaComision = planesFiltradoPorSucursal.filter(
      (item) =>
        item.moneda.codigo === moneda.codigo &&
        item.comisionAseguradora.id === comisionAseguradoraId
    );
    const eliminados = [];
    const primerItem = planesFiltradoPorMonedaComision[0];

    const coberturaIndex = primerItem.planSubcobertura.findIndex(
      (item) =>
        item.cobertura?.id === idCobertura ||
        item.subcobertura?.cobertura.id === idCobertura
    );

    for (let i = 0; i < planesFiltradoPorMonedaComision.length; i += 1) {
      const element = planesFiltradoPorMonedaComision[i];
      const coberturasEliminada = element.planSubcobertura.find(
        (_, indexItem) => indexItem === coberturaIndex
      );
      eliminados.push({ item: coberturasEliminada, index: coberturaIndex });
    }

    for (let i = 0; i < planesFiltradoPorMonedaComision.length; i += 1) {
      const item = planesFiltradoPorMonedaComision[i];
      item.planSubcobertura.splice(coberturaIndex, 1);
    }

    setCoberturasEliminadas([...coberturasEliminadas, ...eliminados]);
    return modelArray;
  };

  const agregarCoberturaEstandar = async (index, values, comisionId) => {
    const modificado = agregarCobertura(model, index, values, comisionId);
    await reloadAll(modificado, index, values.moneda);
    setModel(modificado);
  };
  const onChangePlanEstandar = async (
    valor,
    fila,
    columna,
    indice,
    moneda,
    comisionAseguradoraId
  ) => {
    const copiaAnterior = lodashClonedeep(model);
    const modificado = await onChangePlan(
      model,
      valor,
      fila,
      columna,
      indice,
      moneda,
      comisionAseguradoraId
    );
    setModel(modificado);

    if (
      cambioValor(
        valor,
        copiaAnterior[indice],
        fila,
        columna,
        moneda,
        comisionAseguradoraId
      ) &&
      valor !== undefined
    ) {
      debounceReloadPlan(
        model,
        indice,
        columna,
        (modificado2) => {
          setModel(modificado2);
        },
        moneda,
        comisionAseguradoraId
      );
      setOpenPlanCoberturaItemEditor(false);
    }
  };

  const onChangeCoberturaEstandar = (event, fila, index) => {
    setModel(onChangeCobertura(model, event, fila, index));
  };

  const onDeletePlanEstandar = (columna, indice, comisionAseguradoraId) => {
    const moneda = getMonedaEstandar(model[indice].producto.id);
    setModel(
      onDeletePlan(model, columna, indice, moneda, comisionAseguradoraId)
    );
  };

  const planPerteneceSucursal = (plan, moneda, sucursal) => {
    return (
      plan.moneda.codigo === moneda.codigo &&
      (!sucursal ||
        !plan.id_sucursal ||
        (plan.id_sucursal && plan.id_sucursal === sucursal.id))
    );
  };

  const reloadAll = async (modelParam, indice, moneda) => {
    let newPlanLoading = {};
    let sucursal;
    if (modelParam[indice].aseguradoraEmpresa) {
      const idEmpresa = modelParam[indice].aseguradoraEmpresa.id_empresa;
      sucursal = sucursalSeleccionada[idEmpresa];
    }
    for (let i = 0; i < modelParam[indice].planes.length; i += 1) {
      const plan = modelParam[indice].planes[i];
      if (planPerteneceSucursal(plan, moneda, sucursal)) {
        newPlanLoading = { ...newPlanLoading, [plan.id]: true };
      }
    }
    setPlanLoading({ ...planLoading, ...newPlanLoading });
    const planesParaActualizar = [];
    for (let i = 0; i < modelParam[indice].planes.length; i += 1) {
      const plan = modelParam[indice].planes[i];
      if (planPerteneceSucursal(plan, moneda, sucursal)) {
        planesParaActualizar.push(plan);
      }
    }

    const planesActualizados = await instanceRef.instance.post(
      `/plan/calculo/preliminar`,
      {
        planes: planesParaActualizar
      }
    );
    let indicePlanActualizado = 0;
    for (let i = 0; i < modelParam[indice].planes.length; i += 1) {
      const plan = modelParam[indice].planes[i];
      if (planPerteneceSucursal(plan, moneda, sucursal)) {
        // eslint-disable-next-line no-param-reassign
        modelParam[indice].planes[i] =
          planesActualizados.data.data[indicePlanActualizado];
        indicePlanActualizado += 1;
      }
    }

    for (let i = 0; i < modelParam[indice].planes.length; i += 1) {
      const plan = modelParam[indice].planes[i];
      if (planPerteneceSucursal(plan, moneda, sucursal)) {
        newPlanLoading = { ...newPlanLoading, [plan.id]: false };
      }
    }
    setPlanLoading({ ...planLoading, ...newPlanLoading });
  };

  const onDeleteCoberturaEstandar = async (
    idCobertura,
    indice,
    comisionAseguradoraId
  ) => {
    const moneda = getMonedaEstandar(model[indice].producto.id);
    const modificado = onDeleteCobertura(
      model,
      idCobertura,
      indice,
      moneda,
      comisionAseguradoraId
    );
    await reloadAll(modificado, indice, moneda);
    setModel(modificado);
  };

  const onChangePlanTitleEstandar = (indice, idPlan, valor) => {
    setModel(onChangePlanTitle(model, indice, idPlan, valor));
  };

  const getParamsEspecifico = (id) => {
    let mainKeyEncontrado;
    let indexCorredoraEncontrado;
    let indexEmpresaEncontrado;
    Array.from(especificos.entries()).forEach(([mainKey, corredora]) => {
      corredora.list.forEach((empresa, indexCorredora) => {
        empresa.list.forEach((item, indexEmpresa) => {
          if (item.id === id) {
            mainKeyEncontrado = mainKey;
            indexCorredoraEncontrado = indexCorredora;
            indexEmpresaEncontrado = indexEmpresa;
          }
        });
      });
    });
    return {
      mainKey: mainKeyEncontrado,
      indexCorredora: indexCorredoraEncontrado,
      indexEmpresa: indexEmpresaEncontrado
    };
  };

  const onPlanEditFinishEspecifico = async (
    idEmpresa,
    id,
    idPlan,
    init,
    values,
    idComisionAseg
  ) => {
    setOpenPlanEditor(false);
    const encontrado = getParamsEspecifico(idEmpresa);
    const copia = lodashClonedeep(especificos);

    if (idPlan) {
      let plan = copia
        .get(encontrado.mainKey)
        .list[encontrado.indexCorredora].list[
          encontrado.indexEmpresa
        ].planes.find((item) => item.id === idPlan);
      const index = copia
        .get(encontrado.mainKey)
        .list[encontrado.indexCorredora].list[
          encontrado.indexEmpresa
        ].planes.findIndex((item) => item.id === idPlan);
      plan = { ...plan, ...values, changed: true };
      try {
        setPlanLoading({ ...planLoading, [idPlan]: true });

        const response = await instanceRef.instance.post(
          `/plan/calculo/preliminar`,
          {
            planes: [plan]
          }
        );
        const actualizado = response.data.data[0];
        copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list[
          encontrado.indexEmpresa
        ].planes[index] = actualizado;
        setPlanLoading({ ...planLoading, [idPlan]: false });
      } catch (error) {
        errorHandler(error);
        setPlanLoading({ ...planLoading, [idPlan]: false });
      }
    } else {
      const modificado = await agregarPlan(
        copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
        encontrado.indexEmpresa,
        init,
        values,
        idComisionAseg
      );
      copia.get(encontrado.mainKey).list[
        encontrado.indexCorredora
      ].list = modificado;
    }
    setEspecificos(copia);
  };

  const onPlanEditFinishEstandar = async (
    index,
    idPlan,
    init,
    values,
    idComisionAseg
  ) => {
    setOpenPlanEditor(false);
    const copia = lodashClonedeep(model);
    if (idPlan) {
      let plan = copia[index].planes.find((item) => item.id === idPlan);
      const indice = copia[index].planes.findIndex(
        (item) => item.id === idPlan
      );
      plan = { ...plan, ...values, changed: true };
      try {
        setPlanLoading({ ...planLoading, [idPlan]: true });

        const response = await instanceRef.instance.post(
          `/plan/calculo/preliminar`,
          {
            planes: [plan]
          }
        );
        const actualizado = response.data.data[0];
        copia[index].planes[indice] = actualizado;
        setPlanLoading({ ...planLoading, [idPlan]: false });
        setModel(copia);
      } catch (error) {
        errorHandler(error);
        setPlanLoading({ ...planLoading, [idPlan]: false });
      }
    } else {
      const modificado = await agregarPlan(
        copia,
        index,
        init,
        values,
        idComisionAseg
      );
      setModel(modificado);
    }
  };

  const onEditPlanCoberturaItem = (data, idEmpresa, index, producto) => {
    setPlanCoberturaItemEdit({
      ...data,
      idEmpresa,
      index,
      producto,
      franquicia_opcion: data.franquicia_opcion || '',
      franquicia_criterio: data.franquicia_criterio || '',
      franquicia_monto: data.franquicia_monto || '',
      franquicia_descripcion: data.franquicia_descripcion || '',
      franquicia_costo_min: data.franquicia_costo_min || '',
      franquicia_costo_max: data.franquicia_costo_max || '',
      franquicia_config: data.franquicia_config
        ? {
            value: data.franquicia_config.parcial_franquicia,
            label: `(${data.franquicia_config.parcial_franquicia}) ${
              data.franquicia_config.tipo_franquicia === 'F'
                ? data.franquicia_config.franquicia || '0'
                : data.franquicia_config.franquicia +
                  data.franquicia_config.descripcion
            }`,
            data: data.franquicia_config || {}
          }
        : null
    });
    setOpenPlanCoberturaItemEditor(true);
  };

  const onEditPlanCoberturaMinMaxItem = (
    data,
    idEmpresa,
    index,
    columna,
    producto
  ) => {
    setPlanCoberturaItemEdit({
      ...data,
      idEmpresa,
      index,
      producto,
      columna
    });
    setOpenPlanCoberturaItemMinMaxEditor(true);
  };

  const updatePlanCoberturaItem = (modelParam, index, idPlan, id, values) => {
    const modelArray = [...modelParam];
    const { planes: nuevosPlanes } = modelArray[index];
    const plan = nuevosPlanes.find((item) => item.id === idPlan);
    const indexPlan = nuevosPlanes.findIndex((item) => item.id === idPlan);

    const planSubcobertura = plan.planSubcobertura.find(
      (item) => item.id === id
    );
    planSubcobertura.changed = true;
    const indexPlanSubcobertura = plan.planSubcobertura.findIndex(
      (item) => item.id === id
    );
    plan.planSubcobertura[indexPlanSubcobertura] = {
      ...planSubcobertura,
      ...values
    };
    nuevosPlanes[indexPlan] = plan;
    modelArray[index].planes = nuevosPlanes;
    return modelArray;
  };

  const onEditPlanCoberturaItemFinishEspecifico = (
    idEmpresa,
    id,
    id_plan,
    values
  ) => {
    const encontrado = getParamsEspecifico(idEmpresa);
    const copia = lodashClonedeep(especificos);

    const modificado = updatePlanCoberturaItem(
      copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
      encontrado.indexEmpresa,
      id_plan,
      id,
      values
    );
    copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list = modificado;
    setEspecificos(copia);
    setOpenPlanCoberturaItemEditor(false);
  };
  const onEditPlanCoberturaItemFinishEstandar = (
    index,
    id,
    id_plan,
    values
  ) => {
    setModel(updatePlanCoberturaItem(model, index, id_plan, id, values));
    setOpenPlanCoberturaItemEditor(false);
  };

  const onEditPlanCoberturaItemFinish = (values) => {
    const { idEmpresa, index, id, id_plan } = planCoberturaItemEdit;
    if (idEmpresa) {
      onEditPlanCoberturaItemFinishEspecifico(idEmpresa, id, id_plan, values);
    } else if (index !== null && index !== undefined) {
      onEditPlanCoberturaItemFinishEstandar(index, id, id_plan, values);
    }
  };

  const onEditPlanCoberturaItemMinMaxFinish = (values) => {
    const { idEmpresa, index, id, id_plan, columna } = planCoberturaItemEdit;
    if (idEmpresa) {
      const moneda = getMonedaEspecifico(idEmpresa, values.producto.id);
      onEditPlanCoberturaItemMinMaxFinishEspecifico(
        idEmpresa,
        id,
        id_plan,
        values,
        columna,
        moneda
      );
    } else if (index !== null && index !== undefined) {
      const moneda = getMonedaEstandar(values.producto.id);
      onEditPlanCoberturaItemMinMaxFinishEstandar(
        index,
        id,
        id_plan,
        values,
        columna,
        moneda
      );
    }
  };

  const onPlanEditFinish = (values) => {
    const {
      idEmpresa,
      index,
      id,
      init,
      idPlan,
      id_comision_aseguradora
    } = planEdit;
    const idComisionAseg = id_comision_aseguradora;
    if (idEmpresa) {
      onPlanEditFinishEspecifico(
        idEmpresa,
        id,
        idPlan,
        init,
        values,
        idComisionAseg
      );
    } else if (index !== null && index !== undefined) {
      onPlanEditFinishEstandar(index, idPlan, init, values, idComisionAseg);
    }
  };
  const onPlanEditConfigFinish = (values) => {
    const { idEmpresa, index, id, init, idPlan } = values;
    if (idEmpresa) {
      onPlanEditFinishEspecifico(idEmpresa, id, idPlan, init, values);
    } else if (index !== null && index !== undefined) {
      onPlanEditFinishEstandar(index, idPlan, init, values);
    }
  };

  const agregarPlanEstandar = (index, idPlan, init, idComisionAseg) => {
    const { producto } = model[index];
    const moneda = getMonedaEstandar(producto.id);
    const datosExtra =
      producto.codigo === 1
        ? {
            sumaAsegurada: '',
            cerokm: false,
            importacion: false,
            volante_cambiado: false,
            submodelo: { plazas: 5, descripcion_tipo: 'AUTOMOVIL' }
          }
        : {};

    if (idPlan) {
      const plan = model[index].planes.find((item) => item.id === idPlan);

      setPlanEdit({
        index,
        init,
        idPlan,
        producto,
        monto_total: plan.monto_total || '0',
        titulo: plan.titulo,
        datosExtra: {
          ...plan.datosExtra,
          sumaAsegurada: plan.datosExtra?.sumaAsegurada || '',
          importacion: !plan.datosExtra?.representante
        },
        moneda,
        producto_cerrado: plan.producto_cerrado ? plan.producto_cerrado : false,
        aplica_formula: plan.aplica_formula,
        aplica_descuento: plan.aplica_descuento,
        tasa_config: plan.tasa_config,
        tasa_pura: plan.tasa_pura,
        costo_minimo: plan.costo_minimo,
        monto_contado_final: plan.monto_contado_final,
        montos: plan.montos,
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config
          ? {
              value: plan.franquicia_config.parcial_franquicia,
              label: `(${plan.franquicia_config.parcial_franquicia}) ${
                plan.franquicia_config.tipo_franquicia === 'F'
                  ? plan.franquicia_config.franquicia || '0'
                  : plan.franquicia_config.franquicia +
                    plan.franquicia_config.descripcion
              }`,
              data: plan.franquicia_config || {}
            }
          : null,
        json_producto_sistema_core: plan.json_producto_sistema_core || {},
        franquicias: plan.franquicias || [],
        id_comision_aseguradora: plan.id_comision_aseguradora
      });
    } else {
      setPlanEdit({
        index,
        init,
        producto,
        monto_total: '0',
        titulo: '',
        datosExtra,
        moneda,
        producto_cerrado: false,
        aplica_formula: null,
        aplica_descuento: null,
        tasa_config: null,
        tasa_pura: null,
        costo_minimo: {},
        monto_contado_final: null,
        montos: [],
        franquicia_opcion: null,
        franquicia_criterio: null,
        franquicia_monto: 0,
        franquicia_descripcion: null,
        franquicia_costo_min: 0,
        franquicia_costo_max: 0,
        franquicia_config: null,
        json_producto_sistema_core: {},
        franquicias: [],
        id_comision_aseguradora: idComisionAseg
      });
    }

    setOpenPlanEditor(true);
  };

  const getPlanConfigEstandar = (index, idPlan, init) => {
    const { producto } = model[index];
    if (idPlan) {
      const plan = model[index].planes.find((item) => item.id === idPlan);

      return {
        index,
        init,
        idPlan,
        producto,
        titulo: plan.titulo,
        controles: plan.controles || [],
        montos: plan.montos || [],
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config || null,
        franquicias: plan.franquicias || [],
        json_producto_sistema_core: plan.json_producto_sistema_core || {}
      };
    }
    return {
      index,
      init,
      producto,
      titulo: '',
      controles: [],
      montos: [],
      franquicia_opcion: null,
      franquicia_criterio: null,
      franquicia_monto: 0,
      franquicia_descripcion: null,
      franquicia_costo_min: 0,
      franquicia_costo_max: 0,
      franquicia_config: null,
      franquicias: [],
      json_producto_sistema_core: {}
    };

    // setOpenPlanConfigEditor(true);
  };

  const agregarPlanEspecifico = (
    idEmpresa,
    init,
    idPlan,
    idComisionAseguradora
  ) => {
    const encontrado = getParamsEspecifico(idEmpresa);
    const { producto } = especificos.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list[encontrado.indexEmpresa];
    const datosExtra =
      producto.codigo === 1
        ? {
            sumaAsegurada: '0',
            cerokm: false,
            importacion: false,
            volante_cambiado: false,
            submodelo: { plazas: 5, descripcion_tipo: 'AUTOMOVIL' }
          }
        : {};
    const moneda = getMonedaEspecifico(idEmpresa, producto.id);

    if (idPlan) {
      const plan = especificos
        .get(encontrado.mainKey)
        .list[encontrado.indexCorredora].list[
          encontrado.indexEmpresa
        ].planes.find((item) => item.id === idPlan);
      setPlanEdit({
        idEmpresa,
        init,
        idPlan,
        producto,
        monto_total: plan.monto_total,
        titulo: plan.titulo,
        datosExtra: {
          ...plan.datosExtra,
          sumaAsegurada: plan.datosExtra?.sumaAsegurada || '0',
          importacion: !plan.datosExtra?.representante
        },
        moneda,
        producto_cerrado: plan.producto_cerrado ? plan.producto_cerrado : false,
        aplica_formula: plan.aplica_formula,
        aplica_descuento: plan.aplica_descuento,
        tasa_config: plan.tasa_config,
        tasa_pura: plan.tasa_pura,
        costo_minimo: plan.costo_minimo,
        monto_contado_final: plan.monto_contado_final,
        montos: plan.montos,
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config
          ? {
              value: plan.franquicia_config.parcial_franquicia,
              label: `(${plan.franquicia_config.parcial_franquicia}) ${
                plan.franquicia_config.tipo_franquicia === 'F'
                  ? plan.franquicia_config.franquicia || '0'
                  : plan.franquicia_config.franquicia +
                    plan.franquicia_config.descripcion
              }`,
              data: plan.franquicia_config || {}
            }
          : null,
        json_producto_sistema_core: plan.json_producto_sistema_core || {},
        franquicias: plan.franquicias || [],
        id_comision_aseguradora: plan.id_comision_aseguradora
      });
    } else {
      setPlanEdit({
        idEmpresa,
        init,
        producto,
        monto_total: '0',
        titulo: '',
        datosExtra,
        moneda,
        producto_cerrado: false,
        aplica_formula: null,
        aplica_descuento: null,
        tasa_config: null,
        tasa_pura: null,
        costo_minimo: {},
        monto_contado_final: null,
        montos: [],
        franquicia_opcion: null,
        franquicia_criterio: null,
        franquicia_monto: 0,
        franquicia_descripcion: null,
        franquicia_costo_min: 0,
        franquicia_costo_max: 0,
        franquicia_config: null,
        json_producto_sistema_core: {},
        franquicias: [],
        id_comision_aseguradora: idComisionAseguradora
      });
    }

    setOpenPlanEditor(true);
  };

  const agregarFranquiciaPlanEspecifico = (idEmpresa, init, idPlan) => {
    const encontrado = getParamsEspecifico(idEmpresa);
    const { producto } = especificos.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list[encontrado.indexEmpresa];
    const moneda = getMonedaEspecifico(idEmpresa, producto.id);
    if (idPlan) {
      const plan = especificos
        .get(encontrado.mainKey)
        .list[encontrado.indexCorredora].list[
          encontrado.indexEmpresa
        ].planes.find((item) => item.id === idPlan);

      const datosExtra =
        producto.codigo === 1
          ? {
              sumaAsegurada: '0',
              cerokm: false,
              importacion: false,
              volante_cambiado: false,
              submodelo: { plazas: 5, descripcion_tipo: 'AUTOMOVIL' }
            }
          : {};

      setPlanEdit({
        idEmpresa,
        init,
        idPlan,
        producto,
        monto_total: plan.monto_total,
        titulo: plan.titulo,
        datosExtra,
        moneda,
        producto_cerrado: plan.producto_cerrado ? plan.producto_cerrado : false,
        aplica_formula: plan.aplica_formula,
        aplica_descuento: plan.aplica_descuento,
        tasa_config: plan.tasa_config,
        tasa_pura: plan.tasa_pura,
        costo_minimo: plan.costo_minimo,
        monto_contado_final: plan.monto_contado_final,
        montos: plan.montos,
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config
          ? {
              value: plan.franquicia_config.parcial_franquicia,
              label: `(${plan.franquicia_config.parcial_franquicia}) ${
                plan.franquicia_config.tipo_franquicia === 'F'
                  ? plan.franquicia_config.franquicia || '0'
                  : plan.franquicia_config.franquicia +
                    plan.franquicia_config.descripcion
              }`,
              data: plan.franquicia_config || {}
            }
          : null,
        json_producto_sistema_core: plan.json_producto_sistema_core || {},
        franquicias: plan.franquicias || []
      });
    }
  };

  const agregarFranquiciaPlanEstandar = (index, idPlan, init) => {
    const { producto } = model[index];
    const moneda = getMonedaEstandar(producto.id);
    if (idPlan) {
      const plan = model[index].planes.find((item) => item.id === idPlan);
      const datosExtra =
        producto.codigo === 1
          ? {
              sumaAsegurada: '0',
              cerokm: false,
              importacion: false,
              volante_cambiado: false,
              submodelo: { plazas: 5, descripcion_tipo: 'AUTOMOVIL' }
            }
          : {};
      setPlanEdit({
        index,
        init,
        idPlan,
        producto,
        monto_total: plan.monto_total || '0',
        titulo: plan.titulo,
        datosExtra,
        moneda,
        producto_cerrado: plan.producto_cerrado ? plan.producto_cerrado : false,
        aplica_formula: plan.aplica_formula,
        aplica_descuento: plan.aplica_descuento,
        tasa_config: plan.tasa_config,
        tasa_pura: plan.tasa_pura,
        costo_minimo: plan.costo_minimo,
        monto_contado_final: plan.monto_contado_final,
        montos: plan.montos,
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config
          ? {
              value: plan.franquicia_config.parcial_franquicia,
              label: `(${plan.franquicia_config.parcial_franquicia}) ${
                plan.franquicia_config.tipo_franquicia === 'F'
                  ? plan.franquicia_config.franquicia || '0'
                  : plan.franquicia_config.franquicia +
                    plan.franquicia_config.descripcion
              }`,
              data: plan.franquicia_config || {}
            }
          : null,
        json_producto_sistema_core: plan.json_producto_sistema_core || {},
        franquicias: plan.franquicias || []
      });
    }
  };

  const agregarSubcoberturaPlanEspecifico = (
    seleccionadas,
    porDefecto,
    idPlan,
    idEmpresa,
    changed
  ) => {
    const encontrado = getParamsEspecifico(idEmpresa);
    const { producto } = especificos.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list[encontrado.indexEmpresa];
    const moneda = getMonedaEspecifico(idEmpresa, producto.id);
    if (idPlan) {
      const datosExtra =
        producto.codigo === 1
          ? {
              sumaAsegurada: '0',
              cerokm: false,
              importacion: false,
              volante_cambiado: false,
              submodelo: { plazas: 5, descripcion_tipo: 'AUTOMOVIL' }
            }
          : {};
      const plan = especificos
        .get(encontrado.mainKey)
        .list[encontrado.indexCorredora].list[
          encontrado.indexEmpresa
        ].planes.find((item) => item.id === idPlan);

      const i = plan.planSubcobertura.findIndex(
        (item) =>
          (item.cobertura?.id || item.subcobertura?.cobertura.id) ===
          porDefecto.id_cobertura
      );

      const planSubcoberturaNew = [...plan.planSubcobertura];
      planSubcoberturaNew[i] = {
        ...planSubcoberturaNew[i],
        subcobertura: porDefecto,
        changed
      };

      const planSubcoberturaOpcionNew = [...new Set([...seleccionadas])];

      const newPlan = {
        idEmpresa,
        idPlan,
        producto,
        monto_total: plan.monto_total,
        titulo: plan.titulo,
        datosExtra,
        moneda,
        planSubcobertura: planSubcoberturaNew,
        planSubcoberturaOpcion: planSubcoberturaOpcionNew,
        producto_cerrado: plan.producto_cerrado ? plan.producto_cerrado : false,
        aplica_formula: plan.aplica_formula,
        aplica_descuento: plan.aplica_descuento,
        tasa_config: plan.tasa_config,
        tasa_pura: plan.tasa_pura,
        costo_minimo: plan.costo_minimo,
        monto_contado_final: plan.monto_contado_final,
        montos: plan.montos,
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config
          ? {
              value: plan.franquicia_config.parcial_franquicia,
              label: `(${plan.franquicia_config.parcial_franquicia}) ${
                plan.franquicia_config.tipo_franquicia === 'F'
                  ? plan.franquicia_config.franquicia || '0'
                  : plan.franquicia_config.franquicia +
                    plan.franquicia_config.descripcion
              }`,
              data: plan.franquicia_config || {}
            }
          : null,
        franquicias: plan.franquicias || [],
        json_producto_sistema_core: plan.json_producto_sistema_core || {}
      };
      return newPlan;
    }
    return {};
  };

  const agregarSubcoberturaPlanEstandar = (
    seleccionadas,
    porDefecto,
    index,
    idPlan,
    changed
  ) => {
    const { producto } = model[index];
    const moneda = getMonedaEstandar(producto.id);
    if (idPlan) {
      const plan = model[index].planes.find((item) => item.id === idPlan);
      const datosExtra =
        producto.codigo === 1
          ? {
              sumaAsegurada: '0',
              cerokm: false,
              importacion: false,
              volante_cambiado: false,
              submodelo: { plazas: 5, descripcion_tipo: 'AUTOMOVIL' }
            }
          : {};
      const i = plan.planSubcobertura.findIndex(
        (item) =>
          (item.cobertura?.id || item.subcobertura?.cobertura.id) ===
          porDefecto.id_cobertura
      );

      const planSubcoberturaNew = [...plan.planSubcobertura];
      planSubcoberturaNew[i] = {
        ...planSubcoberturaNew[i],
        subcobertura: porDefecto,
        changed
      };

      const planSubcoberturaOpcionNew = [...new Set([...seleccionadas])];

      const newPlan = {
        index,
        idPlan,
        producto,
        monto_total: plan.monto_total || '0',
        titulo: plan.titulo,
        datosExtra,
        moneda,
        planSubcobertura: planSubcoberturaNew,
        planSubcoberturaOpcion: planSubcoberturaOpcionNew,
        producto_cerrado: plan.producto_cerrado ? plan.producto_cerrado : false,
        aplica_formula: plan.aplica_formula,
        aplica_descuento: plan.aplica_descuento,
        tasa_config: plan.tasa_config,
        tasa_pura: plan.tasa_pura,
        costo_minimo: plan.costo_minimo,
        monto_contado_final: plan.monto_contado_final,
        montos: plan.montos,
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config
          ? {
              value: plan.franquicia_config.parcial_franquicia,
              label: `(${plan.franquicia_config.parcial_franquicia}) ${
                plan.franquicia_config.tipo_franquicia === 'F'
                  ? plan.franquicia_config.franquicia || '0'
                  : plan.franquicia_config.franquicia +
                    plan.franquicia_config.descripcion
              }`,
              data: plan.franquicia_config || {}
            }
          : null,
        franquicias: plan.franquicias || [],
        json_producto_sistema_core: plan.json_producto_sistema_core || {}
      };

      return newPlan;
    }
    return {};
  };

  const getPlanConfigEspecifico = (idEmpresa, init, idPlan) => {
    const encontrado = getParamsEspecifico(idEmpresa);
    const { producto } = especificos.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list[encontrado.indexEmpresa];
    if (idPlan) {
      const plan = especificos
        .get(encontrado.mainKey)
        .list[encontrado.indexCorredora].list[
          encontrado.indexEmpresa
        ].planes.find((item) => item.id === idPlan);

      return {
        idEmpresa,
        init,
        idPlan,
        producto,
        titulo: plan.titulo,
        controles: plan.controles || [],
        montos: plan.montos || [],
        franquicia_opcion: plan.franquicia_opcion || null,
        franquicia_criterio: plan.franquicia_criterio || null,
        franquicia_monto: plan.franquicia_monto || 0,
        franquicia_descripcion: plan.franquicia_descripcion || null,
        franquicia_costo_min: plan.franquicia_costo_min || 0,
        franquicia_costo_max: plan.franquicia_costo_max || 0,
        franquicia_config: plan.franquicia_config || null,
        franquicias: plan.franquicias || [],
        json_producto_sistema_core: plan.json_producto_sistema_core || {}
      };
    }
    return {
      idEmpresa,
      init,
      producto,
      monto_total: '0',
      titulo: '',
      controles: [],
      montos: [],
      franquicia_opcion: null,
      franquicia_criterio: null,
      franquicia_monto: 0,
      franquicia_descripcion: null,
      franquicia_costo_min: 0,
      franquicia_costo_max: 0,
      franquicia_config: null,
      franquicias: [],
      json_producto_sistema_core: {}
    };
    // setOpenPlanConfigEditor(true);
  };

  const onAddCoberturaEspecifico = (id, producto, comisionId) => {
    setCoberturaEdit({ idEmpresa: id, producto, comisionId });
  };

  const onAddCoberturaEstandar = (index, producto, comisionId) => {
    setCoberturaEdit({ index, producto, comisionId });
  };

  const agregarCoberturaEspecifico = async (id, value, comisionId) => {
    const encontrado = getParamsEspecifico(id);
    const copia = lodashClonedeep(especificos);
    const modificado = agregarCobertura(
      copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
      encontrado.indexEmpresa,
      value,
      comisionId
    );
    await reloadAll(modificado, encontrado.indexEmpresa, value.moneda);
    copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list = modificado;
    setEspecificos(copia);
  };

  const agregarCoberturaFinish = (values) => {
    const { idEmpresa, index, comisionId } = coberturaEdit;
    if (idEmpresa) {
      agregarCoberturaEspecifico(idEmpresa, values, comisionId);
    } else if (index !== null && index !== undefined) {
      agregarCoberturaEstandar(index, values, comisionId);
    }
  };

  const onChangePlanTitle = (modelParam, index, idPlan, valor) => {
    const modelArray = [...modelParam];
    const { planes: nuevosPlanes } = modelArray[index];
    const plan = nuevosPlanes.find((item) => item.id === idPlan);
    const indexPlan = nuevosPlanes.findIndex((item) => item.id === idPlan);
    plan.titulo = valor;
    plan.changed = true;
    nuevosPlanes[indexPlan] = plan;
    modelArray[index].planes = nuevosPlanes;
    return modelArray;
  };

  const onChangePlanTitleEspecifico = async (id, idPlan, valor) => {
    const encontrado = getParamsEspecifico(id);
    const copia = lodashClonedeep(especificos);
    const modificado = onChangePlanTitle(
      copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
      encontrado.indexEmpresa,
      idPlan,
      valor
    );
    copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list = modificado;
    setEspecificos(copia);
  };

  const onEditPlanCoberturaItemMinMaxFinishEstandar = async (
    index,
    id,
    id_plan,
    values,
    columna,
    moneda
  ) => {
    const modificado = onChangePlanMaxMin(model, index, id_plan, id, values);
    setModel(modificado);
    debounceReloadPlan(
      model,
      index,
      columna,
      (modificado2) => {
        setModel(modificado2);
      },
      moneda
    );
    setOpenPlanCoberturaItemMinMaxEditor(false);
  };

  const onEditPlanCoberturaItemMinMaxFinishEspecifico = async (
    idEmpresa,
    id,
    id_plan,
    values,
    columna,
    moneda
  ) => {
    const encontrado = getParamsEspecifico(idEmpresa);
    const copia = lodashClonedeep(especificos);
    const modificado = onChangePlanMaxMin(
      copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
      encontrado.indexEmpresa,
      id_plan,
      id,
      values
    );
    copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list = modificado;
    debounceReloadPlan(
      copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
      encontrado.indexEmpresa,
      columna,
      (modificado2) => {
        const copia2 = lodashClonedeep(especificos);
        copia2.get(encontrado.mainKey).list[
          encontrado.indexCorredora
        ].list = modificado2;
        setEspecificos(copia2);
      },
      moneda
    );
    setEspecificos(copia);
    setOpenPlanCoberturaItemMinMaxEditor(false);
  };

  /**
   * Esta funcion controla que no se ejecuten 2 llamadas a la api de calculo si los valores finales son iguales. Ej.:
   * 1,000,000 es igual a 1,000,000.00.
   * Esto soluciona el problema del CurrencyInputCustom que cuyo onChange se ejecuta tambien en el onBlur. En el onBlur
   * se realiza el formatero y se le agregan los decimales fijos. Ej.: de 1,000,000 a 1,000,000.00.
   * @param {*} valor
   * @param {*} copia
   * @param {*} encontrado
   * @param {*} fila
   * @param {*} columna
   * @param {*} moneda
   * @returns true si el valor
   */
  const cambioValor = (
    valor,
    copia,
    fila,
    columna,
    moneda,
    comisionAseguradoraId
  ) => {
    let planesFiltradoPorSucursal = copia.planes;
    if (copia.aseguradoraEmpresa) {
      const idEmpresa = copia.aseguradoraEmpresa.id_empresa;
      const sucursal = sucursalSeleccionada[idEmpresa];
      planesFiltradoPorSucursal = copia.planes.filter(
        (item) =>
          (item.id_sucursal && item.id_sucursal === sucursal.id) ||
          !item.id_sucursal
      );
    }

    const newModel = planesFiltradoPorSucursal.filter(
      (plan) =>
        plan.moneda.codigo === moneda.codigo &&
        plan.id_comision_aseguradora === comisionAseguradoraId
    );
    const item = newModel[columna];
    const itemEdit = item.planSubcobertura.find(
      (element) => element.id === fila
    );
    if (
      !Number.isNaN(itemEdit.monto) &&
      !Number.isNaN(valor) &&
      Number(itemEdit.monto) === Number(valor)
    ) {
      return false;
    }
    return true;
  };
  const onChangePlanEspecifico = async (
    valor,
    fila,
    columna,
    id,
    moneda,
    comisionAseguradoraId
  ) => {
    const encontrado = getParamsEspecifico(id);
    const copia = lodashClonedeep(especificos);
    const copiaAnterior = lodashClonedeep(copia);
    const modificado = await onChangePlan(
      copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
      valor,
      fila,
      columna,
      encontrado.indexEmpresa,
      moneda,
      comisionAseguradoraId
    );
    copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list = modificado;
    if (
      cambioValor(
        valor,
        copiaAnterior.get(encontrado.mainKey).list[encontrado.indexCorredora]
          .list[encontrado.indexEmpresa],
        fila,
        columna,
        moneda,
        comisionAseguradoraId
      ) &&
      valor !== undefined
    ) {
      debounceReloadPlan(
        copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
        encontrado.indexEmpresa,
        columna,
        (modificado2) => {
          const copia2 = lodashClonedeep(especificos);
          copia2.get(encontrado.mainKey).list[
            encontrado.indexCorredora
          ].list = modificado2;
          setEspecificos(copia2);
        },
        moneda,
        comisionAseguradoraId
      );
    }
    setEspecificos(copia);
  };

  const onChangeCoberturaEspecifico = (event, fila, id) => {
    const encontrado = getParamsEspecifico(id);
    const copia = lodashClonedeep(especificos);
    const modificado = onChangeCobertura(
      copia.get(encontrado.mainKey).list[encontrado.indexCorredora].list,
      event,
      fila,
      encontrado.indexEmpresa
    );
    copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list = modificado;
    setEspecificos(copia);
  };

  const onDeletePlanEspecifico = (columna, id, comisionAseguradoraId) => {
    const encontrado = getParamsEspecifico(id);
    const copia = lodashClonedeep(especificos);
    const modelEspecifico = copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list;
    const moneda = getMonedaEspecifico(
      modelEspecifico[encontrado.indexEmpresa].id,
      modelEspecifico[encontrado.indexEmpresa].producto.id
    );
    const modificado = onDeletePlan(
      modelEspecifico,
      columna,
      encontrado.indexEmpresa,
      moneda,
      comisionAseguradoraId
    );
    copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list = modificado;
    setEspecificos(copia);
  };

  const onDeleteCoberturaEspecifico = async (
    idCobertura,
    id,
    comisionAseguradoraId
  ) => {
    const encontrado = getParamsEspecifico(id);
    const copia = lodashClonedeep(especificos);

    const modelEspecifico = copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list;
    const moneda = getMonedaEspecifico(
      modelEspecifico[encontrado.indexEmpresa].id,
      modelEspecifico[encontrado.indexEmpresa].producto.id
    );

    const modificado = onDeleteCobertura(
      modelEspecifico,
      idCobertura,
      encontrado.indexEmpresa,
      moneda,
      comisionAseguradoraId
    );
    await reloadAll(modificado, encontrado.indexEmpresa, moneda);
    copia.get(encontrado.mainKey).list[
      encontrado.indexCorredora
    ].list = modificado;
    setEspecificos(copia);
  };

  // eslint-disable-next-line prefer-destructuring
  const reloadPlan = React.useCallback(
    async (
      modelParam,
      indice,
      columna,
      onSuccess,
      moneda,
      comisionAseguradoraId
    ) => {
      const modelArray = [...modelParam];
      const newModelPre = modelParam[indice].planes;
      let planesFiltradoPorSucursal = newModelPre;
      if (modelArray[indice].aseguradoraEmpresa) {
        const idEmpresa = modelArray[indice].aseguradoraEmpresa.id_empresa;
        const sucursal = sucursalSeleccionada[idEmpresa];
        planesFiltradoPorSucursal = newModelPre.filter(
          (item) =>
            (item.id_sucursal && item.id_sucursal === sucursal.id) ||
            !item.id_sucursal
        );
      }
      const modelListMoneda = planesFiltradoPorSucursal.filter(
        (item) => item.moneda.codigo === moneda.codigo
      );

      const modelListComision = modelListMoneda.filter(
        (item) => item.comisionAseguradora.id === comisionAseguradoraId
      );
      const newModel = controlMinMax(modelListComision, columna, moneda);
      const item = newModel[columna];
      if (item.datosExtra) {
        item.representante = !item.datosExtra.importacion;
      }
      try {
        setPlanLoading({ ...planLoading, [item.id]: true });
        const response = await instanceRef.instance.post(
          `/plan/calculo/preliminar`,
          {
            planes: [item]
          }
        );
        modelListComision[columna] = {
          ...response.data.data[0]
        };

        let indexPlan;
        if (modelArray[indice].aseguradoraEmpresa) {
          const idEmpresa = modelArray[indice].aseguradoraEmpresa.id_empresa;
          const sucursal = sucursalSeleccionada[idEmpresa];
          indexPlan = newModelPre.findIndex(
            (plan) =>
              plan.id === modelListComision[columna].id &&
              ((item.id_sucursal && item.id_sucursal === sucursal.id) ||
                !item.id_sucursal)
          );
        } else {
          indexPlan = newModelPre.findIndex(
            (plan) => plan.id === modelListComision[columna].id
          );
        }
        newModelPre.splice(indexPlan, 1, modelListComision[columna]);
        modelArray[indice] = {
          ...modelArray[indice],
          planes: [...newModelPre]
        };

        onSuccess(modelArray);
        setPlanLoading({ ...planLoading, [item.id]: false });
      } catch (error) {
        setPlanLoading({ ...planLoading, [item.id]: false });
        if (!axios.isCancel(error)) {
          errorHandler(error);
        }
      }
    },
    [planLoading, sucursalSeleccionada]
  );

  const debounceReloadPlan = React.useMemo(() => {
    return debounce(reloadPlan, 1000);
  }, [reloadPlan]);

  // const debounceReloadPlan = debounce(reloadPlan, 5000, {
  //   leading: false,
  //   trailing: true
  // });

  const onChangePlan = async (
    modelParam,
    value,
    fila,
    columna,
    indice,
    moneda,
    comisionAseguradoraId
  ) => {
    const modelArray = [...modelParam];

    let planesFiltradoPorSucursal = modelArray[indice].planes;
    if (modelArray[indice].aseguradoraEmpresa) {
      const idEmpresa = modelArray[indice].aseguradoraEmpresa.id_empresa;
      const sucursal = sucursalSeleccionada[idEmpresa];
      planesFiltradoPorSucursal = modelArray[indice].planes.filter(
        (item) =>
          (item.id_sucursal && item.id_sucursal === sucursal.id) ||
          !item.id_sucursal
      );
    }

    const newModel = planesFiltradoPorSucursal.filter(
      (plan) =>
        plan.moneda.codigo === moneda.codigo &&
        plan.id_comision_aseguradora === comisionAseguradoraId
    );

    const item = newModel[columna];
    const itemEdit = item.planSubcobertura.find(
      (element) => element.id === fila
    );
    if (value === undefined) {
      itemEdit.monto = undefined;
      itemEdit.changed = true;
    } else if (fila === item.planSubcobertura.length + 1) {
      item.monto_total =
        `${value}` === '-1' || `${value}` === '0'
          ? `${value}`
          : `${value}`.replace(/\D+/g, '');
      item.changed = true;
    } else if (`${value}` === '-1' || `${value}` === '0') {
      itemEdit.monto = `${value}`;
      itemEdit.changed = true;
    } else if (moneda) {
      const config = getCurrencyInputConfig(moneda);
      const newValue = `${value}`;
      const sinSeparador = newValue.replaceAll(config.groupSeparator, '');
      const decimalesNumber = sinSeparador.replaceAll(
        config.decimalSeparator,
        '.'
      );
      itemEdit.monto = decimalesNumber;
      itemEdit.changed = true;
    } else {
      itemEdit.monto = `${value}`.replace(/\D+/g, ''); // Ej: % - Excluye - Incluye
      itemEdit.changed = true;
    }

    const planList = modelParam[indice].planes.map((plan) => {
      if (plan.id === newModel.id) {
        return newModel;
      }
      return plan;
    });
    modelArray[indice] = { ...modelArray[indice], planes: planList };

    return modelArray;
  };

  const onChangePlanMaxMin = (modelParam, index, idPlan, id, values) => {
    const modelArray = [...modelParam];
    const moneda = getMoneda(
      modelParam[index].id,
      modelParam[index].producto.id
    );
    let planesFiltradoPorSucursal = modelArray[index].planes;
    if (modelArray[index].aseguradoraEmpresa) {
      const idEmpresa = modelArray[index].aseguradoraEmpresa.id_empresa;
      const sucursal = sucursalSeleccionada[idEmpresa];
      planesFiltradoPorSucursal = modelArray[index].planes.filter(
        (item) =>
          (item.id_sucursal && item.id_sucursal === sucursal.id) ||
          !item.id_sucursal
      );
    }
    const newModel = planesFiltradoPorSucursal.filter(
      (plan) => plan.id_moneda === moneda.id
    );
    const item = newModel.find((plan) => plan.id === idPlan);
    const itemEdit = item.planSubcobertura.find((element) => element.id === id);
    itemEdit.monto_max = values.monto_max;
    itemEdit.monto_min = values.monto_min;
    itemEdit.changed = true;
    const planList = modelParam[index].planes.map((plan) => {
      if (plan.id === newModel.id) {
        return newModel;
      }
      return plan;
    });
    modelArray[index] = { ...modelArray[index], planes: planList };

    return modelArray;
  };

  const onChangeCobertura = (modelParam, value, fila, indice) => {
    const modelArray = [...modelParam];
    const newModel = modelParam[indice].planes;
    for (let i = 0; i < newModel.length; i += 1) {
      const item = newModel[i];
      const itemEdit = item.planSubcobertura.find(
        (_, index) => index + 1 === fila
      );
      // itemEdit.coberturaItem.descripcion = value.replace(/\r?\n/g, '');
      if (value) {
        itemEdit.cobertura = value;
        itemEdit.cobertura.coberturaItem = {
          descripcion: value.label[0]
        };
      } else {
        itemEdit.cobertura = { coberturaItem: {} };
      }
      itemEdit.cobertura.changed = true;
    }
    modelArray[indice] = { ...modelArray[indice], planes: newModel };
    return modelArray;
  };

  const onChangeMonedaEstandar = (value, item) => {
    const selected = monedas.find((moneda) => moneda.codigo === value);
    const newList = [...monedaProductoEstandarList];
    let indiceExistente;
    newList.map((monedaProducto, index) => {
      if (monedaProducto.idProducto === item.producto.id) {
        indiceExistente = index;
        // Si el producto ya existe en el listado, entonces se elimina y adelante se vuelve agregar con la nueva moneda seleccionada
      }
      return index;
    });
    if (indiceExistente !== undefined) {
      newList.splice(indiceExistente, 1);
    }
    // En el state se agregan los productos cuya moneda se haya seleccionado/modificado
    setMonedaProductoEstandarList([
      ...newList,
      {
        idProducto: item.producto.id,
        moneda: selected
      }
    ]);
  };
  const onChangeMonedaEspecifico = (value, item) => {
    const selected = monedas.find((moneda) => moneda.codigo === value);
    monedaProductoList.map((monedaProducto, index) => {
      if (
        monedaProducto.idProducto === item.producto.id &&
        monedaProducto.idEmpresa === item.id
      ) {
        // Si el producto ya existe en el listado, entonces se elimina y adelante se vuelve agregar con la nueva moneda seleccionada
        monedaProductoList.splice(index, 1);
      }
      return monedaProducto;
    });

    // En el state se agregan los productos cuya moneda se haya seleccionado/modificado
    setMonedaProductoList([
      ...monedaProductoList,
      {
        idEmpresa: item.id,
        idProducto: item.producto.id,
        moneda: selected
      }
    ]);
  };

  const controlMinMax = (planes, columna, moneda) => {
    let max;
    let min;
    const newPlan = planes;
    let sumaAsegurada;
    for (let i = 0; i < newPlan[columna].planSubcobertura.length; i += 1) {
      sumaAsegurada = newPlan[columna].monto_total;
      if (newPlan[columna].datosExtra) {
        sumaAsegurada = newPlan[columna].datosExtra.sumaAsegurada;
      }
      max = newPlan[columna].planSubcobertura[i].monto_max;
      min = newPlan[columna].planSubcobertura[i].monto_min;
      if (!(max > 0 && min > 0)) {
        if (!max > 0) {
          max = newPlan[columna].planSubcobertura[i]?.subcobertura?.monto_max;
        }
        if (!min > 0) {
          min = newPlan[columna].planSubcobertura[i]?.subcobertura?.monto_min;
        }
      }
      const item = newPlan[columna].planSubcobertura[i];
      const montoItem = Number(item.monto);
      if (montoItem > 0) {
        sumaAsegurada = montoItem;
      }
      if (
        (item?.subcobertura?.opcion === 'valor_capital' &&
          newPlan[columna].monto_total &&
          `${item.monto}` !== '-1') ||
        (item?.subcobertura?.opcion === 'valor_capital' && montoItem > 0)
      ) {
        const monto = sumaAsegurada;
        if (monto < min && min) {
          message.info({
            content: `El valor mínimo permitido es de ${formatoMonedaGenerico(
              moneda,
              min
            )}`,
            duration: 10
          });
          newPlan[columna].planSubcobertura[i].monto = min;
          newPlan[columna].planSubcobertura[i].changed = true;
        }
        if (monto > max && max) {
          message.info({
            content: `El valor máximo permitido es de ${formatoMonedaGenerico(
              moneda,
              max
            )}`,
            duration: 10
          });
          newPlan[columna].planSubcobertura[i].monto = max;
          newPlan[columna].planSubcobertura[i].changed = true;
        }
      }
    }
    return newPlan;
  };
  const updateSucursalSeleccionada = (empresa, sucursal) => {
    const sucursalSeleccionadaNuevo = { ...sucursalSeleccionada };
    sucursalSeleccionadaNuevo[empresa.id] = sucursal;
    setSucursalSeleccionada(sucursalSeleccionadaNuevo);
  };

  const getMoneda = (idEmpresa, idProducto) => {
    if (idEmpresa) {
      return getMonedaEspecifico(idEmpresa, idProducto);
    }
    return getMonedaEstandar(idProducto);
  };

  const getMonedaEstandar = (idProducto) => {
    // Las monedas modificadas se encuentran guardadas por cada Empresa y Producto en el state monedaProductoList
    if (monedaProductoEstandarList.length > 0) {
      const productoEncontrado = monedaProductoEstandarList.filter(
        (item) => item.idProducto === idProducto
      )[0];
      if (productoEncontrado) {
        return productoEncontrado.moneda;
      }
    }
    // Si la moneda no fue modificada, en el Plan Editor se maneja por defecto GS o Moneda Local
    return monedas && monedas.find((moneda) => moneda.codigo === 'gs');
  };

  const getMonedaEspecifico = (idEmpresa, idProducto) => {
    // Las monedas modificadas se encuentran guardadas por cada Empresa y Producto en el state monedaProductoList
    if (monedaProductoList.length > 0) {
      const productoEncontrado = monedaProductoList.filter(
        (item) => item.idProducto === idProducto && item.idEmpresa === idEmpresa
      )[0];
      if (productoEncontrado) {
        return productoEncontrado.moneda;
      }
    }
    // Si la moneda no fue modificada, en el Plan Editor se maneja por defecto GS o Moneda Local
    return monedas && monedas.find((moneda) => moneda.codigo === 'gs');
  };

  const mostrarTablaEstandar = (planes, idEmpresa, idProducto, idComision) => {
    const monedaProductoSelected = getMonedaEstandar(idProducto);
    if (!monedaProductoSelected) {
      return false;
    }
    if (planes.length > 0) {
      if (
        planes.find(
          (item) =>
            item.moneda.codigo === monedaProductoSelected.codigo &&
            item.comisionAseguradora &&
            item.comisionAseguradora.id === idComision
        )
      ) {
        return true;
      }
    }
    return false;
  };

  const mostrarTablaEspecifico = (
    planes,
    idEmpresa,
    idProducto,
    idComisionAseg
  ) => {
    const monedaEmpresaProductoSelected = getMonedaEspecifico(
      idEmpresa,
      idProducto
    );
    if (!monedaEmpresaProductoSelected) {
      return false;
    }
    if (planes.length > 0) {
      if (
        planes.find(
          (item) =>
            item.moneda.codigo === monedaEmpresaProductoSelected.codigo &&
            item.comisionAseguradora &&
            item.comisionAseguradora.id === idComisionAseg
        )
      ) {
        return true;
      }
    }
    return false;
  };

  const getMonedas = async () => {
    try {
      const monedasResponse = await instanceRef.instance.get(`/moneda`);
      if (monedasResponse.data?.data) {
        setMonedas(monedasResponse.data?.data);
      }
    } catch (error) {
      errorHandler(error, 'No se pudo obtener monedas');
      setLoading(false);
    }
  };

  const getComisionAseguradoraList = useCallback(async () => {
    try {
      const response = await instanceRef.instance.get(`/comisionaseguradora`, {
        params: { idAseguradora }
      });
      if (response.data?.data) {
        setComisionAseguradoraList(response.data?.data);
      }
    } catch (error) {
      errorHandler(
        error,
        'No se pudo obtener las comisiones de la Aseguradora'
      );
      setLoading(false);
    }
  }, [idAseguradora, setComisionAseguradoraList]);

  useEffect(() => {
    if (idAseguradora) {
      loadAseguradora(idAseguradora);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idAseguradora]);

  useEffect(() => {
    if (idAseguradora) {
      getComisionAseguradoraList();
    }
  }, [idAseguradora, getComisionAseguradoraList]);

  useEffect(() => {
    getMonedas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const monedasResponse = await instanceRef.instance.get(`/moneda`);

  const ExpandedCoberturas = ({ record, moneda }) => {
    const { subcoberturas } = record;

    return subcoberturas.map((e) => (
      <Fragment key={e.id}>
        {(e.opcion === 'valor_capital' ||
          e.opcion === 'porcentaje_capital') && (
          <Descriptions
            bordered
            size="small"
            column={2}
            contentStyle={{ padding: 2 }}
            labelStyle={{ padding: 2 }}
            style={{ marginLeft: 8, marginBottom: 8, marginTop: 4 }}
          >
            <Descriptions.Item label="Tipo">
              {getDescripcionOpcion(e.opcion)}
            </Descriptions.Item>
            <Descriptions.Item label="Tasa Pura">
              {e.tasa_pura || 'Sin definir'}
            </Descriptions.Item>
            {e.opcion === 'porcentaje_capital' && (
              <Descriptions.Item label="Porcentaje">
                {getCriterio(record, moneda)}
              </Descriptions.Item>
            )}
          </Descriptions>
        )}
        {e.opcion === 'monto_fijo' && (
          <Descriptions
            bordered
            size="small"
            column={2}
            contentStyle={{ padding: 2 }}
            labelStyle={{ padding: 2 }}
            style={{ marginLeft: 8, marginBottom: 8, marginTop: 4 }}
          >
            <Descriptions.Item label="Tipo">
              {getDescripcionOpcion(e.opcion)}
            </Descriptions.Item>
            <Descriptions.Item label="Tasa Pura">
              {e.tasa_pura || 'Sin definir'}
            </Descriptions.Item>
            <Descriptions.Item label="Monto">
              {getCriterio(record, moneda)}
            </Descriptions.Item>
          </Descriptions>
        )}
        {(e.opcion === 'suma_tabla_rc' || e.opcion === 'suma_tabla_ovp') && (
          <Descriptions
            bordered
            size="small"
            column={2}
            contentStyle={{ padding: 2 }}
            labelStyle={{ padding: 2 }}
            style={{ marginLeft: 8, marginBottom: 8, marginTop: 4 }}
          >
            <Descriptions.Item label="Tipo">
              {getDescripcionOpcion(e.opcion)}
            </Descriptions.Item>
            <Descriptions.Item label="Tasa Pura">
              {e.tasa_pura || 'Sin definir'}
            </Descriptions.Item>
            <Descriptions.Item label="Costo Mínimo">
              {e.costo_min && formatoMonedaGenerico(moneda, e.costo_min)}
            </Descriptions.Item>
            <Descriptions.Item label="Costo Máximo">
              {e.costo_max && formatoMonedaGenerico(moneda, e.costo_max)}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Fragment>
    ));
  };

  const SucursalSelector = ({ empresa }) => {
    return (
      <div
        style={{
          marginRight: 16
        }}
      >
        <SelectableListModal
          textButton="Sucursales"
          title="Listado de sucursales"
          placeholder="Buscar sucursales"
          width={1000}
          resetValue
          notNull
          button={
            <Button icon={<SelectOutlined />} type="primary" ghost>
              {sucursalSeleccionada?.[empresa.id]?.descripcion || ''}
            </Button>
          }
          columnsData={columns}
          url={`/sucursal?id_empresa=${empresa.id}`}
          setNewList={(newValue) => {
            updateSucursalSeleccionada(empresa, newValue[0]);
          }}
        />
      </div>
    );
  };

  const getUrl = (idProducto, idMoneda) => {
    let url = `/cobertura/search?idAseguradora=${idAseguradora}`;
    if (idProducto) {
      url += `&idProducto=${idProducto}`;
    }
    if (idMoneda) {
      url += `&idMoneda=${idMoneda}`;
    }
    return url;
  };

  return (
    <ResponsiveContainer size="large">
      <Card title="Configuración de planes" style={{ textAlign: 'left' }}>
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div>
            <>
              <Typography.Title level={3}>Planes Estándar</Typography.Title>
              {comisionAseguradoraList.map((comision, indexComision) => (
                <>
                  <Collapse expandIconPosition="end">
                    <Panel
                      header={<PanelHeader empresa="" comision={comision} />}
                      key={`planEstandar${comision.id}`}
                      className="collapse-centered"
                    >
                      <div style={{ overflowX: 'auto' }}>
                        <Tabs
                          activeKey={activeTabEstandar[indexComision]}
                          size="large"
                          onChange={(tab) =>
                            onChangeActiveTabEst(indexComision, tab)
                          }
                        >
                          {model &&
                            model.map((item, index) => (
                              <TabPane
                                tab={item.producto.descripcion}
                                key={index}
                              >
                                {monedas &&
                                mostrarTablaEstandar(
                                  item.planes,
                                  item.id,
                                  item.id_producto,
                                  comision.id
                                ) ? (
                                  <>
                                    <Row gutter={[32, 16]}>
                                      <Col>
                                        <Space style={{ width: '50%' }}>
                                          <>
                                            <SelectableListModal
                                              isMultiple
                                              textButton="Agregar coberturas"
                                              title="Listado de coberturas"
                                              placeholder="Buscar coberturas"
                                              width={1000}
                                              resetValue
                                              notNull
                                              columnsData={columnsCoberturas}
                                              url={getUrl(
                                                item.id_producto,
                                                getMoneda(
                                                  null,
                                                  item.id_producto
                                                ).id
                                              )}
                                              button={
                                                <Button
                                                  type="primary"
                                                  ghost
                                                  icon={
                                                    <InsertRowBelowOutlined />
                                                  }
                                                  onClick={() =>
                                                    onAddCoberturaEstandar(
                                                      index,
                                                      model.producto,
                                                      comision.id
                                                    )
                                                  }
                                                >
                                                  Agregar coberturas
                                                </Button>
                                              }
                                              expandable={{
                                                expandedRowRender: (record) => (
                                                  <ExpandedCoberturas
                                                    record={record}
                                                    moneda={
                                                      getMoneda(
                                                        null,
                                                        item.id_producto
                                                      ).id
                                                    }
                                                  />
                                                ),
                                                rowExpandable: () => true
                                              }}
                                              setObjectList={(value) => {
                                                agregarCoberturaFinish({
                                                  data: value,
                                                  moneda: getMoneda(
                                                    null,
                                                    item.id_producto
                                                  )
                                                });
                                              }}
                                            />
                                            <Button
                                              type="dashed"
                                              icon={<InsertRowRightOutlined />}
                                              onClick={() =>
                                                agregarPlanEstandar(
                                                  index,
                                                  null,
                                                  null,
                                                  comision.id
                                                )
                                              }
                                            >
                                              Agregar plan
                                            </Button>
                                          </>
                                        </Space>
                                      </Col>
                                      <Col>
                                        <Space
                                          style={{
                                            width: '50%',
                                            display: 'inline'
                                          }}
                                        >
                                          {monedas && (
                                            <MonedaSelector
                                              value={
                                                getMonedaEstandar(
                                                  item.producto.id
                                                ).codigo
                                              }
                                              monedas={monedas}
                                              onChange={(e) =>
                                                onChangeMonedaEstandar(
                                                  e.target.value,
                                                  item
                                                )
                                              }
                                            />
                                          )}
                                        </Space>
                                      </Col>
                                    </Row>

                                    <br />
                                    <Space
                                      direction="vertical"
                                      align="start"
                                      style={{ display: 'flex' }}
                                    >
                                      <PlanEditor
                                        puedeEditar
                                        producto={item.producto}
                                        planLoading={planLoading}
                                        planes={item.planes}
                                        moneda={getMonedaEstandar(
                                          item.producto.id
                                        )}
                                        comisionAseguradora={comision}
                                        onEditPlan={(idPlan) =>
                                          agregarPlanEstandar(
                                            index,
                                            idPlan,
                                            false,
                                            comision.id
                                          )
                                        }
                                        onEditPlanFranquicia={(idPlan) => {
                                          agregarFranquiciaPlanEstandar(
                                            index,
                                            idPlan,
                                            false
                                          );
                                          setOpenPlanFranquiciaEditor(true);
                                        }}
                                        onEditPlanSubcoberturas={(
                                          seleccionadas,
                                          porDefecto,
                                          idPlan,
                                          changed
                                        ) => {
                                          onPlanEditConfigFinish(
                                            agregarSubcoberturaPlanEstandar(
                                              seleccionadas,
                                              porDefecto,
                                              index,
                                              idPlan,
                                              changed
                                            )
                                          );
                                        }}
                                        onEditPlanConfig={
                                          model &&
                                          ((idPlan) => (
                                            <PlanConfigControles
                                              onOk={onPlanEditConfigFinish}
                                              plan={getPlanConfigEstandar(
                                                index,
                                                idPlan,
                                                false
                                              )}
                                              disabled={planLoading[idPlan]}
                                            />
                                          ))
                                        }
                                        onEditPlanCoberturaItem={(data) =>
                                          onEditPlanCoberturaItem(
                                            data,
                                            null,
                                            index,
                                            item.producto
                                          )
                                        }
                                        onEditPlanCoberturaMinMaxItem={(
                                          data,
                                          _,
                                          columna
                                        ) =>
                                          onEditPlanCoberturaMinMaxItem(
                                            data,
                                            null,
                                            index,
                                            columna,
                                            item.producto
                                          )
                                        }
                                        onChangePlanTitle={(
                                          { target: { value: nuevoValor } },
                                          idPlan
                                        ) =>
                                          onChangePlanTitleEstandar(
                                            index,
                                            idPlan,
                                            nuevoValor
                                          )
                                        }
                                        onChangePlan={(
                                          event,
                                          fila,
                                          columna
                                        ) => {
                                          // Currency maneja value y el Input maneja event
                                          const nuevoValor =
                                            event && event.target
                                              ? event.target.value
                                              : event;
                                          onChangePlanEstandar(
                                            nuevoValor,
                                            fila,
                                            columna,
                                            index,
                                            getMonedaEstandar(item.producto.id),
                                            comision.id
                                          );
                                        }}
                                        onChangeCobertura={(event, fila) =>
                                          onChangeCoberturaEstandar(
                                            event,
                                            fila,
                                            index
                                          )
                                        }
                                        onDeletePlan={(columna) =>
                                          onDeletePlanEstandar(
                                            columna,
                                            index,
                                            comision.id
                                          )
                                        }
                                        onDeleteCobertura={(idCobertura) =>
                                          onDeleteCoberturaEstandar(
                                            idCobertura,
                                            index,
                                            comision.id
                                          )
                                        }
                                        opcionesDePago={{
                                          numeroCuotas: 12
                                        }}
                                      />
                                    </Space>
                                  </>
                                ) : (
                                  <Row gutter={[32, 16]}>
                                    <Col>
                                      <Space style={{ width: '50%' }}>
                                        <Button
                                          type="dashed"
                                          onClick={() =>
                                            agregarPlanEstandar(
                                              index,
                                              null,
                                              true,
                                              comision.id
                                            )
                                          }
                                        >
                                          Configurar
                                        </Button>
                                      </Space>
                                    </Col>
                                    {monedas && (
                                      <Col>
                                        <Space
                                          style={{
                                            width: '50%',
                                            display: 'inline'
                                          }}
                                        >
                                          <MonedaSelector
                                            value={
                                              getMonedaEstandar(
                                                item.producto.id
                                              ).codigo
                                            }
                                            monedas={monedas}
                                            onChange={(e) =>
                                              onChangeMonedaEstandar(
                                                e.target.value,
                                                item
                                              )
                                            }
                                          />
                                        </Space>
                                      </Col>
                                    )}
                                  </Row>
                                )}
                              </TabPane>
                            ))}
                        </Tabs>
                      </div>
                    </Panel>
                  </Collapse>
                  <br />
                </>
              ))}

              <br />
              <br />
              <Typography.Title level={3}>Planes Específicos</Typography.Title>
              {especificos &&
                Array.from(especificos.values()).map(
                  (corredora, indexCorredora) => (
                    <Card
                      key={indexCorredora}
                      size="small"
                      style={{ marginBottom: 20 }}
                      // title={corredora.data?.nombre || 'Sin Corredora'}
                      title={
                        <CardHeader
                          corredora={corredora.data?.nombre || 'Sin Corredora'}
                          empresa={corredora.list[0].data}
                        />
                      }
                    >
                      {comisionAseguradoraList.map(
                        (comision, indexComision) => (
                          <>
                            <Collapse expandIconPosition="end">
                              {especificos &&
                                Array.from(corredora.list.values()).map(
                                  (value, index) => {
                                    return (
                                      <Panel
                                        header={
                                          <PanelHeader
                                            empresa={value.data}
                                            comision={comision}
                                          />
                                        }
                                        key={index}
                                        className="collapse-centered"
                                      >
                                        <div style={{ overflowX: 'auto' }}>
                                          <Tabs
                                            tabBarExtraContent={{
                                              right: (
                                                <SucursalSelector
                                                  empresa={value.data}
                                                />
                                              )
                                            }}
                                            activeKey={
                                              activeTabEspecifico[
                                                indexCorredora
                                              ]?.[indexComision]?.[index]
                                            }
                                            size="large"
                                            onChange={(tab) =>
                                              onChangeActiveTabEsp(
                                                indexCorredora,
                                                index,
                                                tab,
                                                indexComision
                                              )
                                            }
                                          >
                                            {value.list.map(
                                              (item, indexProductos) => (
                                                <TabPane
                                                  tab={
                                                    item.producto.descripcion
                                                  }
                                                  key={indexProductos}
                                                >
                                                  {monedas &&
                                                  mostrarTablaEspecifico(
                                                    filterSucursal(
                                                      item.planes,
                                                      value.data.id
                                                    ),
                                                    item.id,
                                                    item.id_producto,
                                                    comision.id
                                                  ) ? (
                                                    <>
                                                      <Row gutter={[32, 16]}>
                                                        <Col>
                                                          <Space
                                                            style={{
                                                              width: '50%'
                                                            }}
                                                          >
                                                            <SelectableListModal
                                                              isMultiple
                                                              textButton="Agregar coberturas"
                                                              title="Listado de coberturas"
                                                              placeholder="Buscar coberturas"
                                                              width={1000}
                                                              resetValue
                                                              notNull
                                                              columnsData={
                                                                columnsCoberturas
                                                              }
                                                              button={
                                                                <Button
                                                                  type="primary"
                                                                  ghost
                                                                  icon={
                                                                    <InsertRowBelowOutlined />
                                                                  }
                                                                  onClick={() =>
                                                                    onAddCoberturaEspecifico(
                                                                      item.id,
                                                                      item.producto,
                                                                      comision.id
                                                                    )
                                                                  }
                                                                >
                                                                  Agregar
                                                                  coberturas
                                                                </Button>
                                                              }
                                                              url={getUrl(
                                                                item.id_producto,
                                                                getMoneda(
                                                                  item.id,
                                                                  item.id_producto
                                                                ).id
                                                              )}
                                                              expandable={{
                                                                expandedRowRender: (
                                                                  record
                                                                ) => (
                                                                  <ExpandedCoberturas
                                                                    record={
                                                                      record
                                                                    }
                                                                    moneda={
                                                                      getMoneda(
                                                                        item.id,
                                                                        item.id_producto
                                                                      ).id
                                                                    }
                                                                  />
                                                                ),
                                                                rowExpandable: () =>
                                                                  true
                                                              }}
                                                              setObjectList={(
                                                                newValue
                                                              ) => {
                                                                agregarCoberturaFinish(
                                                                  {
                                                                    data: newValue,
                                                                    moneda: getMoneda(
                                                                      item.id,
                                                                      item
                                                                        .producto
                                                                        .id
                                                                    )
                                                                  }
                                                                );
                                                              }}
                                                            />
                                                            <Button
                                                              type="dashed"
                                                              icon={
                                                                <InsertRowRightOutlined />
                                                              }
                                                              onClick={() =>
                                                                agregarPlanEspecifico(
                                                                  item.id,
                                                                  null,
                                                                  null,
                                                                  comision.id
                                                                )
                                                              }
                                                            >
                                                              Agregar plan
                                                            </Button>
                                                          </Space>
                                                        </Col>
                                                        <Col>
                                                          <Space
                                                            style={{
                                                              width: '50%',
                                                              display: 'inline'
                                                            }}
                                                          >
                                                            {monedas && (
                                                              <MonedaSelector
                                                                value={
                                                                  getMonedaEspecifico(
                                                                    item.id,
                                                                    item
                                                                      .producto
                                                                      .id
                                                                  ).codigo
                                                                }
                                                                monedas={
                                                                  monedas
                                                                }
                                                                onChange={(e) =>
                                                                  onChangeMonedaEspecifico(
                                                                    e.target
                                                                      .value,
                                                                    item
                                                                  )
                                                                }
                                                              />
                                                            )}
                                                          </Space>
                                                        </Col>
                                                      </Row>

                                                      <br />
                                                      <Space
                                                        direction="vertical"
                                                        align="start"
                                                        style={{
                                                          display: 'flex'
                                                        }}
                                                      >
                                                        <PlanEditor
                                                          puedeEditar
                                                          producto={
                                                            item.producto
                                                          }
                                                          planLoading={
                                                            planLoading
                                                          }
                                                          planes={filterSucursal(
                                                            item.planes,
                                                            value.data.id
                                                          )}
                                                          moneda={getMonedaEspecifico(
                                                            item.id,
                                                            item.producto.id
                                                          )}
                                                          comisionAseguradora={
                                                            comision
                                                          }
                                                          onEditPlan={(
                                                            idPlan
                                                          ) =>
                                                            agregarPlanEspecifico(
                                                              item.id,
                                                              false,
                                                              idPlan,
                                                              comision.id
                                                            )
                                                          }
                                                          onEditPlanFranquicia={(
                                                            idPlan
                                                          ) => {
                                                            agregarFranquiciaPlanEspecifico(
                                                              item.id,
                                                              false,
                                                              idPlan
                                                            );
                                                            setOpenPlanFranquiciaEditor(
                                                              true
                                                            );
                                                          }}
                                                          onEditPlanSubcoberturas={(
                                                            seleccionadas,
                                                            porDefecto,
                                                            idPlan,
                                                            changed
                                                          ) => {
                                                            onPlanEditConfigFinish(
                                                              agregarSubcoberturaPlanEspecifico(
                                                                seleccionadas,
                                                                porDefecto,
                                                                idPlan,
                                                                item.id,
                                                                changed
                                                              )
                                                            );
                                                          }}
                                                          onEditPlanConfig={
                                                            especificos &&
                                                            ((idPlan) => (
                                                              <PlanConfigControles
                                                                onOk={
                                                                  onPlanEditConfigFinish
                                                                }
                                                                plan={getPlanConfigEspecifico(
                                                                  item.id,
                                                                  false,
                                                                  idPlan
                                                                )}
                                                                disabled={
                                                                  planLoading[
                                                                    idPlan
                                                                  ]
                                                                }
                                                              />
                                                            ))
                                                          }
                                                          onEditPlanCoberturaItem={(
                                                            data
                                                          ) =>
                                                            onEditPlanCoberturaItem(
                                                              data,
                                                              item.id,
                                                              null,
                                                              item.producto
                                                            )
                                                          }
                                                          onEditPlanCoberturaMinMaxItem={(
                                                            data,
                                                            _,
                                                            columna
                                                          ) =>
                                                            onEditPlanCoberturaMinMaxItem(
                                                              data,
                                                              item.id,
                                                              null,
                                                              columna,
                                                              item.producto
                                                            )
                                                          }
                                                          onChangePlanTitle={(
                                                            {
                                                              target: {
                                                                value: nuevoValor
                                                              }
                                                            },
                                                            idPlan
                                                          ) =>
                                                            onChangePlanTitleEspecifico(
                                                              item.id,
                                                              idPlan,
                                                              nuevoValor
                                                            )
                                                          }
                                                          onChangePlan={(
                                                            event,
                                                            fila,
                                                            columna
                                                          ) => {
                                                            // Currency maneja value y el Input maneja event
                                                            const nuevoValor =
                                                              event &&
                                                              event.target
                                                                ? event.target
                                                                    .value
                                                                : event;

                                                            onChangePlanEspecifico(
                                                              nuevoValor,
                                                              fila,
                                                              columna,
                                                              item.id,
                                                              getMonedaEspecifico(
                                                                item.id,
                                                                item.producto.id
                                                              ),
                                                              comision.id
                                                            );
                                                          }}
                                                          onChangeCobertura={(
                                                            event,
                                                            fila
                                                          ) =>
                                                            onChangeCoberturaEspecifico(
                                                              event,
                                                              fila,
                                                              item.id
                                                            )
                                                          }
                                                          onDeletePlan={(
                                                            columna
                                                          ) =>
                                                            onDeletePlanEspecifico(
                                                              columna,
                                                              item.id,
                                                              comision.id
                                                            )
                                                          }
                                                          onDeleteCobertura={(
                                                            idCobertura
                                                          ) =>
                                                            onDeleteCoberturaEspecifico(
                                                              idCobertura,
                                                              item.id,
                                                              comision.id
                                                            )
                                                          }
                                                          opcionesDePago={{
                                                            numeroCuotas: 12
                                                          }}
                                                        />
                                                      </Space>
                                                    </>
                                                  ) : (
                                                    <Row gutter={[32, 16]}>
                                                      <Col>
                                                        <Space
                                                          style={{
                                                            width: '50%'
                                                          }}
                                                        >
                                                          <Button
                                                            type="dashed"
                                                            onClick={() =>
                                                              agregarPlanEspecifico(
                                                                item.id,
                                                                true,
                                                                null,
                                                                comision.id
                                                              )
                                                            }
                                                          >
                                                            Configurar
                                                          </Button>
                                                        </Space>
                                                      </Col>
                                                      {monedas && (
                                                        <Col>
                                                          <Space
                                                            style={{
                                                              width: '50%',
                                                              display: 'inline'
                                                            }}
                                                          >
                                                            <MonedaSelector
                                                              value={
                                                                getMonedaEspecifico(
                                                                  item.id,
                                                                  item.producto
                                                                    .id
                                                                ).codigo
                                                              }
                                                              monedas={monedas}
                                                              onChange={(e) =>
                                                                onChangeMonedaEspecifico(
                                                                  e.target
                                                                    .value,
                                                                  item
                                                                )
                                                              }
                                                            />
                                                          </Space>
                                                        </Col>
                                                      )}
                                                    </Row>
                                                  )}
                                                </TabPane>
                                              )
                                            )}
                                          </Tabs>
                                        </div>
                                      </Panel>
                                    );
                                  }
                                )}
                            </Collapse>
                            <br />
                          </>
                        )
                      )}
                    </Card>
                  )
                )}
            </>
            <br />
            <Button
              type="primary"
              htmlType="submit"
              onClick={onFinish}
              loading={loading}
              disabled={loading}
              icon={<SaveOutlined />}
            >
              Actualizar
            </Button>
          </div>
        </Spin>
      </Card>
      <PlanConfig
        open={openPlanEditor}
        onCancel={() => setOpenPlanEditor(false)}
        onOk={onPlanEditFinish}
        plan={planEdit}
        idAseguradora={idAseguradora}
        // productos={productos}
        // tiposRiesgo={tiposRiesgo}
        // riesgos={riesgos}
        // objetos={objetos}
      />
      <FranquiciaPorRangos
        open={openPlanFranquiciaEditor}
        onOk={(values) => {
          onPlanEditConfigFinish(values);
          setOpenPlanFranquiciaEditor(false);
        }}
        onCancel={() => setOpenPlanFranquiciaEditor(false)}
        model={planEdit}
        idAseguradora={idAseguradora}
      />
      <PlanCoberturaItemConfig
        open={openPlanCoberturaItemEditor}
        onCancel={() => setOpenPlanCoberturaItemEditor(false)}
        onOk={onEditPlanCoberturaItemFinish}
        model={planCoberturaItemEdit}
        idAseguradora={idAseguradora}
        moneda={
          planCoberturaItemEdit &&
          getMoneda(
            planCoberturaItemEdit.idEmpresa,
            planCoberturaItemEdit.producto?.id
          )
        }
      />
      <PlanCoberturaItemMinMaxConfig
        open={openPlanCoberturaItemMinMaxEditor}
        onCancel={() => setOpenPlanCoberturaItemMinMaxEditor(false)}
        onOk={onEditPlanCoberturaItemMinMaxFinish}
        model={planCoberturaItemEdit}
        moneda={
          planCoberturaItemEdit &&
          getMoneda(
            planCoberturaItemEdit.idEmpresa,
            planCoberturaItemEdit.producto?.id
          )
        }
      />
    </ResponsiveContainer>
  );
};

export default AdminAseguradoraPlanes;
